import { AgGridReact } from 'ag-grid-react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import 'ag-grid-enterprise';
import { columnDefs } from './_utils/defination-config';
import { getAllScrapeRequest } from '../../services/apiService';
import { toast } from 'react-toastify';
import CreateRequest from './_components/CreateRequest';
import UpdateEditRequest from './_components/UpdateEditRequest';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';

const pageSize = 10;

const JobScrapingData = () => {
  const [gridApi, setGridApi] = React.useState(null);
  const [showResults, setShowResults] = useState(false);

  // Initialize selectedRows from localStorage
  const [selectedRows, setSelectedRows] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('selectedJobIds') || '[]');
    } catch (error) {
      return [];
    }
  });

  const [openEditModal, setOpenEditModal] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [selectedRowForEdit, setSelectedRowForEdit] = useState(null);

  const history = useHistory();
  const location = useLocation();

  console.log(gridApi, showResults, openEditModal, 'adjka');
  const queryParams = new URLSearchParams(location.search);
  const selectedIdParam = queryParams.get('selectedIds');
  const preSelectedIds = useMemo(
    () => (selectedIdParam ? selectedIdParam.split(',') : []),
    [selectedIdParam]
  );
  console.log(preSelectedIds, 'selectedid');

  const agGridColumnDefs = useMemo(() => {
    return columnDefs({
      setShowResults,
      setSelectedRows,
      setOpenEditModal,
      setSelectedRowForEdit,
    });
  }, []);

  let lastRequestedPage = null;

  const getServerSideDatasource = () => {
    return {
      getRows: async (params) => {
        const { startRow, endRow } = params.request;
        const currentPage = Math.floor(startRow / pageSize) + 1;

        if (currentPage === lastRequestedPage) {
          return;
        }

        lastRequestedPage = currentPage;
        console.log(params.request, 'request');
        const payload = {
          page: startRow,
        };
        console.log(payload, endRow, currentPage, 'pauloadh');

        try {
          console.log('yuvraj');
          const response = await getAllScrapeRequest(currentPage);
          console.log('yuvraj later');
          const allData = response?.data || [];
          const totalCount = response?.totalCount;

          params.successCallback(allData, totalCount);
        } catch (err) {
          toast.error('Failed to fetch data');
          params.failCallback();
        }
      },
    };
  };

  // Force grid refresh when data changes
  const refreshGrid = useCallback(() => {
    if (gridApi) {
      setTimeout(() => {
        gridApi.refreshCells();
      }, 100);
    }
  }, [gridApi]);

  // Update selectedRows when localStorage changes (from checkbox interactions)
  useEffect(() => {
    const handleStorageChange = () => {
      try {
        const storedIds = JSON.parse(
          localStorage.getItem('selectedJobIds') || '[]'
        );
        setSelectedRows(storedIds);
        refreshGrid(); // Refresh grid to update checkbox states
      } catch (error) {
        console.error('Error reading from localStorage:', error);
      }
    };

    // Listen for custom storage events
    window.addEventListener('localStorageUpdate', handleStorageChange);

    return () => {
      window.removeEventListener('localStorageUpdate', handleStorageChange);
    };
  }, [refreshGrid]);

  const handleShowResults = () => {
    if (selectedRows.length === 0) {
      toast.error('Please select at least one job');
    } else {
      console.log(selectedRows, 'rowshere');
      const selectedIds = selectedRows.map((row) => row);

      console.log(selectedIds, 'ids');
      localStorage.setItem('selectedJobIds', JSON.stringify(selectedIds));

      history.push({
        pathname: '/scrape-data',
        state: { jobData: selectedRows },
        search: `?selectedIds=${selectedIds.join(',')}`,
      });
    }
  };
  const handlezClearSelectedRows = () => {
    localStorage.removeItem('selectedJobIds');
    setSelectedRows([]);
    reloadData();
  };

  const handleNewRequest = () => {
    setOpenCreateModal(true);
  };

  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setSelectedRowForEdit(null);
  };

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    const datasource = getServerSideDatasource();
    params.api.setServerSideDatasource(datasource);
  }, []);

  const reloadData = () => {
    lastRequestedPage = null;
    if (gridApi) {
      setTimeout(() => {
        const datasource = getServerSideDatasource();
        gridApi.setServerSideDatasource(datasource);
      }, 0);
    }
  };

  const handleUpdateSuccess = () => {
    if (gridApi) {
      setTimeout(() => {
        gridApi.refreshServerSide({ purge: true });
      }, 0);
    }
    handleCloseEditModal();
    toast.success('Request updated successfully');
  };

  const handleCreateSuccess = () => {
    if (gridApi) {
      setTimeout(() => {
        const datasource = getServerSideDatasource();
        gridApi.setServerSideDatasource(datasource);
      }, 0);
    }
    setOpenCreateModal(false);
  };

  useEffect(() => {
    
    if (gridApi) {
      reloadData();
    }
  }, [gridApi]);

  return (
    <div style={{ height: '92vh' }} className='flex flex-col h-screen'>
      {/* Header Section */}
      <div className='bg-white py-6 px-6 shadow-md'>
        <div className='flex items-center justify-between'>
          <div className='text-2xl font-semibold'>Scrape Requests</div>
          <div className='flex gap-4'>
            <button
              className={`px-4 py-2 rounded-md transition 
    ${
      selectedRows?.length === 0
        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
        : 'bg-blue-600 text-white hover:bg-blue-700'
    }
  `}
              onClick={handleShowResults}
              disabled={selectedRows?.length === 0}
            >
              Show Results ({selectedRows?.length})
            </button>
            <button
              className={`px-4 py-2 rounded-md transition 
    ${
      selectedRows?.length === 0
        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
        : 'bg-blue-600 text-white hover:bg-blue-700'
    }
  `}
              onClick={handlezClearSelectedRows}
              disabled={selectedRows?.length === 0}
            >
              Clear ({selectedRows?.length})
            </button>
            <button
              onClick={handleNewRequest}
              className='bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition'
            >
              Create Request
            </button>
          </div>
        </div>
      </div>

      {openCreateModal && (
        <CreateRequest
          openCreateModal={openCreateModal}
          setOpenCreateModal={setOpenCreateModal}
          onRequestCreated={handleCreateSuccess}
          onGridReady={onGridReady}
          refetchData={reloadData}
        />
      )}

      <div className='flex-1 overflow-hidden'>
        <div
          className='ag-theme-alpine h-full w-full'
          style={{ height: '100%' }}
        >
          <AgGridReact
            columnDefs={agGridColumnDefs}
            onGridReady={onGridReady}
             tooltipShowDelay={500} // Delay before showing tooltip (ms)
            tooltipHideDelay={2000} // How long tooltip stays visible (ms)
            enableBrowserTooltips={true}
            rowHeight={52}
            rowModelType='serverSide'
            serverSideStoreType='partial'
            animateRows={true}
            serverSideInfiniteScroll={true}
            pagination={true}
            paginationPageSize={pageSize}
            cacheBlockSize={pageSize}
            suppressPaginationPanel={false}
            domLayout='normal'
          />
        </div>
      </div>

      {openEditModal && selectedRowForEdit && (
        <UpdateEditRequest
          openEditModal={openEditModal}
          handleCloseEditModal={handleCloseEditModal}
          selectedRowForEdit={selectedRowForEdit}
          onUpdateSuccess={handleUpdateSuccess}
          gridApi={gridApi}
          refetchData={reloadData}
        />
      )}
    </div>
  );
};

export default JobScrapingData;
